export function convertToFloatingUi(position) {
    switch (position) {
        case 'up':
            return 'top';
        case 'down':
            return 'bottom';
        case 'left':
            return 'left';
        case 'right':
            return 'right';
        default:
            return 'top';
    }
}
export function getPositionClassName(placement, middlewareData) {
    let className = '';
    className = className.concat(getPlacementWithoutAlignment(placement));
    let alignment = '';
    if (middlewareData.shift) {
        if (middlewareData.shift.x > 0 || middlewareData.shift.y > 0) {
            alignment = '-end';
        }
        else if (middlewareData.shift.x < 0 || middlewareData.shift.y < 0) {
            alignment = '-start';
        }
    }
    if (!alignment) {
        return placement;
    }
    else {
        return className + alignment;
    }
}
export function getPlacementWithoutAlignment(placement) {
    return placement.split('-')[0];
}
export function tryPlacements(triggerRect, position, tooltipHeight, tooltipOffset) {
    switch (position) {
        case 'top':
            return (tryTopPlacement(triggerRect.top, tooltipHeight) ||
                tryBottomPlacement(triggerRect.bottom, tooltipHeight) ||
                trySidePlacements(triggerRect.top, triggerRect.bottom, tooltipHeight, tooltipOffset) ||
                getBestFitPosition(triggerRect.top, triggerRect.bottom, tooltipOffset));
        case 'bottom':
            return (tryBottomPlacement(triggerRect.bottom, tooltipHeight) ||
                tryTopPlacement(triggerRect.top, tooltipHeight) ||
                trySidePlacements(triggerRect.top, triggerRect.bottom, tooltipHeight, tooltipOffset) ||
                getBestFitPosition(triggerRect.top, triggerRect.bottom, tooltipOffset));
        case 'right':
        case 'left':
            return (trySidePlacements(triggerRect.top, triggerRect.bottom, tooltipHeight, tooltipOffset) ||
                tryBottomPlacement(triggerRect.bottom, tooltipHeight) ||
                tryTopPlacement(triggerRect.top, tooltipHeight) ||
                getBestFitPosition(triggerRect.top, triggerRect.bottom, tooltipOffset));
    }
}
function getBestFitPosition(triggerTop, triggerBottom, tooltipOffset) {
    return distanceToBottom(triggerTop, tooltipOffset) > distanceToTop(triggerBottom, tooltipOffset)
        ? 'right-end'
        : 'right-start';
}
function trySidePlacements(triggerTop, triggerBottom, tooltipHeight, tooltipOffset) {
    return (trySideCenter(triggerTop, triggerBottom, tooltipHeight) ||
        trySideStart(triggerBottom, tooltipHeight, tooltipOffset) ||
        trySideEnd(triggerTop, tooltipHeight, tooltipOffset));
}
function tryTopPlacement(triggerTop, tooltipHeight) {
    return triggerTop > tooltipHeight + 7 ? 'top' : '';
}
function tryBottomPlacement(triggerBottom, tooltipHeight) {
    return window.innerHeight - triggerBottom > tooltipHeight + 7 ? 'bottom' : '';
}
function trySideCenter(triggerTop, triggerBottom, tooltipHeight) {
    return triggerTop > tooltipHeight / 2 && window.innerHeight - triggerBottom > tooltipHeight / 2
        ? 'right'
        : '';
}
function trySideStart(triggerBottom, tooltipHeight, tooltipOffset) {
    return distanceToTop(triggerBottom, tooltipOffset) > tooltipHeight ? 'right-start' : '';
}
function distanceToTop(triggerBottom, tooltipOffset) {
    return triggerBottom + tooltipOffset;
}
function trySideEnd(triggerTop, tooltipHeight, tooltipOffset) {
    return distanceToBottom(triggerTop, tooltipOffset) > tooltipHeight ? 'right-end' : '';
}
function distanceToBottom(triggerTop, tooltipOffset) {
    return window.innerHeight - (triggerTop - tooltipOffset);
}
export function shiftTooltip(tooltipRect, position, triggerRect, tooltipX, tooltipY, tooltipOffset) {
    switch (position) {
        case 'top-end':
        case 'bottom-end':
            return shiftTooltipRight(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset);
        case 'left-end':
        case 'right-end':
            return shiftTooltipDown(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset);
        case 'top-start':
        case 'bottom-start':
            return shiftTooltipLeft(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset);
        case 'left-start':
        case 'right-start':
            return shiftTooltipUp(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset);
    }
    return { x: 0, y: 0, translateString: '' };
}
function shiftTooltipRight(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset) {
    const tooltipShiftAmount = { x: 0, y: 0 };
    tooltipShiftAmount.x = triggerRect.x - tooltipOffset - tooltipRect.x;
    tooltipShiftAmount.y = 0;
    const translateString = `translate(${tooltipShiftAmount.x + tooltipX}px, ${tooltipY}px)`;
    return {
        x: tooltipShiftAmount.x,
        y: tooltipShiftAmount.y,
        translateString: translateString,
    };
}
function shiftTooltipDown(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset) {
    const tooltipShiftAmount = { x: 0, y: 0 };
    tooltipShiftAmount.x = 0;
    tooltipShiftAmount.y = triggerRect.y - tooltipOffset - tooltipRect.y;
    const translateString = `translate(${tooltipX}px, ${triggerRect.y - tooltipOffset - tooltipRect.y + tooltipY}px)`;
    return {
        x: tooltipShiftAmount.x,
        y: tooltipShiftAmount.y,
        translateString: translateString,
    };
}
function shiftTooltipLeft(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset) {
    const tooltipShiftAmount = { x: 0, y: 0 };
    tooltipShiftAmount.x = triggerRect.right + tooltipOffset - tooltipRect.right;
    tooltipShiftAmount.y = 0;
    const translateString = `translate(${triggerRect.right + tooltipOffset - tooltipRect.right + tooltipX}px, ${tooltipY}px)`;
    return {
        x: tooltipShiftAmount.x,
        y: tooltipShiftAmount.y,
        translateString: translateString,
    };
}
function shiftTooltipUp(triggerRect, tooltipRect, tooltipX, tooltipY, tooltipOffset) {
    const tooltipShiftAmount = { x: 0, y: 0 };
    tooltipShiftAmount.x = 0;
    tooltipShiftAmount.y = triggerRect.bottom + tooltipOffset - tooltipRect.bottom;
    const translateString = `translate(${tooltipX}px, ${triggerRect.bottom + tooltipOffset - tooltipRect.bottom + tooltipY}px)`;
    return {
        x: tooltipShiftAmount.x,
        y: tooltipShiftAmount.y,
        translateString: translateString,
    };
}
